import React, { useEffect } from "react";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup"; // For validation
import {
    setMobileBackColor,
    setMobileCardColor,
    setMobileTextColor,
} from "../utility";
import { Container, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import Toast from "../common/toast";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { ArrowBackOutlined, Try } from "@mui/icons-material";
import { t } from "i18next";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BottomNavBar from "../components/BottomNavBar";

const Profile = ({ tableQr, tableName }) => {
    const [profileData, setProfileData] = useState();
    const [loading, setLoading] = useState(false);
    const queryString = window.location.search;
    const urlParam = new URLSearchParams(queryString);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [phone, setPhone] = useState(localStorage.getItem("login_phone") || "");

    const navigate = useNavigate();
    const lang = localStorage.getItem("lang");

    const mobileLoginToken = localStorage.getItem('mobileLoginToken');
    const headers = {
        Authorization: `Bearer ${mobileLoginToken}`,
        'Content-Type': 'application/json',
    };


    const fetchProfileData = async () => {

        setLoading(true);
        const authToken = localStorage.getItem('mobileLoginToken');
        if (!authToken) {
            toast.error("Authentication token is missing.");
            setLoading(false);
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/get-profile`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            setProfileData(response.data.data || {});
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(`Error fetching profile data: ${error.response?.data?.message || error.message}`);
        }
    };

    useEffect(() => {
        fetchProfileData();
    }, []);


    const [toastSettings, setToastSettings] = useState({
        open: false,
        message: "",
        success: false,
    });

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: '20px',
        },
        profileImage: {
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            marginBottom: '20px',
        },
        form: {
            width: '100%',
            maxWidth: '400px',
            margin: '0 auto',
        },
        phoneInput: {
            width: '72%',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '10px',
            fontSize: '16px',
        },
        errorMessage: {
            color: 'red',
            marginBottom: '10px',
        },
        button: {
            width: '100%',
        },
        verificationCodeInput: {
            marginBottom: '20px',
        },
    };

    const handleBack = () => {
        if (urlParam.get("section")) {
            navigate(
                `/${tableName}/${tableQr}/sections?section=${urlParam.get(
                    "section"
                )}&t=${urlParam.get("t")}&lang=${localStorage.getItem("lang")}`
            );
        } else {
            navigate(
                `/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get(
                    "t"
                )}&lang=${localStorage.getItem("lang")}`
            );
        }
    };

    const handleBackHome = () => {
        navigate(
            `/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get(
                "t"
            )}&lang=${localStorage.getItem("lang")}`
        );
    };

    const onImageError = (e) => {
        e.target.src = coverSample;
    };

    const { data, isLoading, isFetching, isError, error } = useQuery(
        "public-details",
        async () => {
            try {
                const timeZone = localStorage.getItem("timezone")
                    ? localStorage.getItem("timezone")
                    : "";

                const promise = await axios.get(
                    `${process.env.REACT_APP_API}/menus/${tableQr}/public-details`,
                    { headers: { localization: localStorage.getItem("lang"), timeZone } }
                );
                if (promise.status === 200) {
                    if (!localStorage.getItem("showOption")) {
                        localStorage.setItem(
                            "showOption",
                            promise.data.data.mobile_settings?.showOption
                        );
                    }
                    if (promise.data.data.mobile_settings?.theme === "costomize") {
                        localStorage.setItem(
                            "theme",
                            promise.data.data.mobile_settings?.theme
                        );
                        localStorage.setItem(
                            "textColor",
                            promise.data?.data.mobile_settings.colorProps.text
                        );
                        localStorage.setItem(
                            "backColor",
                            promise.data?.data.mobile_settings.colorProps.back
                        );
                        localStorage.setItem(
                            "cardColor",
                            promise.data?.data.mobile_settings.colorProps.card
                        );
                        localStorage.setItem(
                            "highlights",
                            promise.data?.data.mobile_settings.colorProps.highlights
                        );
                    } else {
                        if (
                            localStorage.getItem("theme") !== "dark" &&
                            localStorage.getItem("theme") !== "light"
                        ) {
                            localStorage.setItem(
                                "theme",
                                promise.data.data.mobile_settings?.theme
                            );
                        }
                    }
                }
                return promise;
            } catch (error) { }
        }
    );


    const handleCloseToast = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setToastSettings({ open: false, message: "", success: false });
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(t("Name Is Required")),
        email: Yup.string()
            .email(t("Invalid email address"))
            .required(t("Email Is Required")),
    });

    const goHome = () => {
        navigate(`/${tableName}/${tableQr}/menus?lang=${localStorage.getItem("lang")}`);
    }

    const handleSendCode = async () => {
        // setLoading(true);
        if (mobileLoginToken) {
            try {
                const sendOtpRes = await axios.post(`${process.env.REACT_APP_API}/update-phone-number-send-otp`, {
                    'phone': phone
                }, { headers });
                if (sendOtpRes?.data?.success) {
                    // setLoading(false);
                    toast.success(
                        <div className="alignByLang">
                            {t("verification code sent successfully")}

                        </div>
                    )
                    setVerificationCode("");
                    setDialogOpen(true);

                } else {
                    // setLoading(false);

                    toast.error(
                        <div className="alignByLang">
                            {t("Error while sending the verification code.")}
                        </div>
                    );
                }
            } catch (error) {
                // setLoading(false);

                toast.error(
                    <div className="alignByLang">
                        {t("Error while sending the verification code.") + " " + error.message}
                    </div>
                );
            }
        } else {
            // setLoading(false);

            toast.error(
                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <span>{t("Please login to continue")}</span>

                    </div>
                    <div>
                        <button
                            onClick={goHome}
                            style={{
                                // marginLeft: '10px',
                                color: '#fff',
                                backgroundColor: '#ff6347',
                                border: 'none',
                                padding: '5px 10px',
                                cursor: 'pointer',
                                borderRadius: '5px',
                                textDecoration: 'none'
                            }}
                        >
                            {t("login")}
                        </button>
                    </div>

                </div>
            );
        }


    };


    const handleVerifyCode = async () => {
        setLoading(true);

        if (mobileLoginToken) {
            if (verificationCode && verificationCode.length > 0) {
                try {
                    const checkOtpRes = await axios.post(`${process.env.REACT_APP_API}/update-phone-number-cehck-otp`, {
                        'phone': phone,
                        'otp': verificationCode
                    }, { headers });
                    if (checkOtpRes?.data?.success) {
                        setLoading(false);
                        localStorage.setItem("login_phone", phone)
                        toast.success(
                            <div className="alignByLang">
                                {t("Phone updated successfully")}
                            </div>
                        );
                        localStorage.setItem("login_phone", phone);
                        localStorage.setItem("mobileLoginToken", checkOtpRes?.data?.data?.token || "")
                        setDialogOpen(false);
                        handleLogout();

                    } else {
                        setLoading(false);

                        toast.error(
                            <div className="alignByLang">
                                {t("Error while verifing the code!")}
                            </div>
                        );
                    }
                } catch (error) {
                    setLoading(false);

                    toast.error(
                        <div className="alignByLang">
                            {t("Error while verifing the code!") + " " + error}
                        </div>
                    );
                }
            } else {
                setLoading(false);

                toast.error(
                    <div className="alignByLang">
                        {t("Please enter the verification code!")}
                    </div>
                );
            }
        } else {
            setLoading(false);

            toast.error(
                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <span>{t("Please login to continue")}</span>

                    </div>
                    <div>
                        <button
                            onClick={goHome}
                            style={{
                                // marginLeft: '10px',
                                color: '#fff',
                                backgroundColor: '#ff6347',
                                border: 'none',
                                padding: '5px 10px',
                                cursor: 'pointer',
                                borderRadius: '5px',
                                textDecoration: 'none'
                            }}
                        >
                            {t("login")}
                        </button>
                    </div>

                </div>
            );
        }
    };

    const handleLogout = async () => {
        await localStorage.setItem("mobileLoginToken", "");
        navigate(`/${tableName}/${tableQr}/menus?lang=${lang}`);
    };

    const updateProfileData = async (values) => {
        // setLoading(true);

        try {
            const profileParams = {
                name: values?.name || "",
                email: values?.email || "",
                address: values?.address || "",
                gender: values?.gender || "",
                birth_date: values?.birth_date || ""
            }
            const checkUpdateProfile = await axios.post(`${process.env.REACT_APP_API}/update-profile`, profileParams, { headers });
            if (checkUpdateProfile?.data?.success) {
                // setLoading(false);

                toast.success(
                    <div className="alignByLang">
                        {t("Profile updated successfully")}
                    </div>
                );
                // fetchProfileData();
            } else {
                // setLoading(false);

                toast.error(
                    <div className="alignByLang">
                        {t("Error while updating the profile!")}
                    </div>
                );
            }
        } catch (error) {
            // setLoading(false);

            toast.error(
                <div className="alignByLang">
                    {t("Error while updating the profile!") + " " + error}
                </div>
            );
        }
    }

    const handleOpenDialog = () => {
        if (phone) {
            handleSendCode();
        } else {
            toast.error(
                <div>
                    {t("Phone number is required")}
                </div>)
        }
    }

    if (isLoading || loading) {
        return <Loading />;
    }

    return (
        <div
            className={`min-vh-100`}
            style={{ backgroundColor: setMobileBackColor() }}
        >
            <ToastContainer />
            <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Container fluid>
                <div style={{ marginBottom: 70 }} className="row">
                    <div className="col-lg-8 d-none d-lg-block">
                        <div className="vh-100 mt-5 text-center d-flex-justify-content-center align-items-center">
                            <div style={{ marginTop: "20%" }}>
                                <img
                                    src={data.data.data?.logo || no_image}
                                    className="me-4"
                                    style={{ width: "250px", height: "250px" }}
                                    onError={onImageError}
                                />
                                <h1
                                    className="mt-4 head-font"
                                    style={{ color: setMobileTextColor() }}
                                >
                                    {data.data.data?.venu_name}
                                </h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 ms-auto p-0">
                        <div className="mobile-side-screen">
                            <div className="slider-mobile">
                                <img
                                    src={data?.data.data.cover || coverSample}
                                    onError={onImageError}
                                    className="slider-mobile-image"
                                />
                                <Navbar
                                    className={`d-flex justify-content-between align-items-center mobile-top-nav`}
                                    style={{ backgroundColor: setMobileBackColor() }}
                                >
                                    <Button
                                        variant="text"
                                        className={`ms-2 dark-color cursor`}
                                        style={{ color: setMobileTextColor() }}
                                        onClick={() => handleBack()}
                                    >
                                        <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                                    </Button>

                                    <Navbar.Brand className="text-center">
                                        <img
                                            src={data?.data.data.logo || no_image}
                                            className="me-4 slider-mobile-logo cursor"
                                            onError={onImageError}
                                            onClick={handleBackHome}
                                        />
                                    </Navbar.Brand>
                                </Navbar>
                            </div>

                            <div className="sections">
                                <div
                                    className="sections-content"
                                    style={{ marginTop: "64px", marginBottom: "24px" }}
                                >
                                    <Formik
                                        initialValues={{ name: profileData?.name || "", address: profileData?.address || "", phone: profileData?.phone || "", email: profileData?.email || "", gender: profileData?.gender || "", birth_date: profileData?.birth_date || "" }}
                                        validationSchema={validationSchema}
                                        onSubmit={(values) => {
                                            updateProfileData(values);
                                        }}
                                    >
                                        {({ values, setFieldValue }) => (
                                            <Form>
                                                <div className="d-flex flex-column align-items-center">
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="phone"
                                                            className="form-label d-block"
                                                        >
                                                            {t("Phone Number")}
                                                        </label>

                                                        <div style={{ display: 'flex', justifyContent: "space-between", flexDirection: "row" }}>
                                                            <Field name="phone">
                                                                {({ field }) => (
                                                                    <PhoneInput
                                                                        className="head-font"
                                                                        {...field}
                                                                        placeholder={t("Enter phone number")}
                                                                        value={localStorage.getItem("login_phone") || values.phone}
                                                                        onChange={(value) => {
                                                                            setFieldValue("phone", value)
                                                                            setPhone(value)
                                                                        }}
                                                                        defaultCountry="SA"
                                                                        style={styles.phoneInput}
                                                                    />
                                                                )}
                                                            </Field>
                                                            <Button
                                                                className="head-font"
                                                                style={{ width: "20%" }}
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={() => handleOpenDialog()}
                                                            >
                                                                {t("Change")}
                                                            </Button>
                                                        </div>
                                                        <ErrorMessage name="phone" component="div" className="text-danger" />
                                                    </div>
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="name"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("Name")}
                                                        </label>
                                                        <Field
                                                            name="name"
                                                            type="text"
                                                            value={values.name}
                                                            className="form-control head-font"
                                                            placeholder={t("Enter Your Name")}
                                                            onChange={(e) => setFieldValue("name", e.target.value)}
                                                        />
                                                        <ErrorMessage
                                                            name="name"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>
                                                    {/* Gender */}
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="gender"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("Gender")}
                                                        </label>
                                                        <Field
                                                            as="select"
                                                            name="gender"
                                                            className="form-control head-font"
                                                            value={values.gender}
                                                            onChange={(e) => setFieldValue("gender", e.target.value)}
                                                        >
                                                            <option value="">{t("Select Gender")}</option>
                                                            <option value="male">{t("Male")}</option>
                                                            <option value="female">{t("Female")}</option>
                                                        </Field>
                                                        <ErrorMessage
                                                            name="gender"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>

                                                    {/* Birth Date */}
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="birth_date"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("Birth Date")}
                                                        </label>
                                                        <Field
                                                            name="birth_date"
                                                            type="date"
                                                            className="form-control head-font"
                                                            value={values.birth_date}
                                                            onChange={(e) => setFieldValue("birth_date", e.target.value)}
                                                        />
                                                        <ErrorMessage
                                                            name="birth_date"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>


                                                    <div className="mb-3 w-75 text-center alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="address"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("Address")}
                                                        </label>
                                                        <Field
                                                            name="address"
                                                            value={values.address}
                                                            type="text"
                                                            className="form-control head-font"
                                                            placeholder={t("Address")}
                                                            onChange={(e) => setFieldValue("address", e.target.value)}

                                                        />
                                                        <ErrorMessage
                                                            name="address"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>
                                                    <div className="mb-3 w-75 text-center head-font alignByLang">
                                                        <label
                                                            style={{ color: setMobileTextColor() }}
                                                            htmlFor="email"
                                                            className="form-label d-block head-font"
                                                        >
                                                            {t("E-mail")}
                                                        </label>
                                                        <Field
                                                            name="email"
                                                            type="email"
                                                            value={values.email}
                                                            className="form-control head-font"
                                                            placeholder={t("Enter Your Email")}
                                                            onChange={(e) => setFieldValue("email", e.target.value)}

                                                        />
                                                        <ErrorMessage
                                                            name="email"
                                                            component="div"
                                                            className="text-danger head-font"
                                                        />
                                                    </div>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        color="primary"
                                                        className="mt-3 head-font"
                                                    >
                                                        {t("save")}
                                                    </Button>
                                                </div>
                                            </Form>


                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                        <Dialog className="alignByLang" open={dialogOpen} onClose={() => setDialogOpen(false)}>
                            <DialogTitle className="head-font">{t("Enter Verification Code")}</DialogTitle>
                            <DialogContent className="head-font alignByLang">
                                <TextField
                                    className="head-font alignByLang"
                                    required
                                    label={t("Verification Code")}
                                    variant="outlined"
                                    value={verificationCode}
                                    onChange={(e) => setVerificationCode(e.target.value)}
                                    fullWidth
                                    style={styles.verificationCodeInput}

                                />
                            </DialogContent>
                            <DialogActions>
                                <Button className="head-font" onClick={handleVerifyCode} color="primary">
                                    {t("Verify")}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>

                    <Toast
                        open={toastSettings.open}
                        message={toastSettings.message}
                        resetToast={handleCloseToast}
                        success={toastSettings.success}
                    />
                </div>
            </Container>
            <BottomNavBar qr={tableQr} qrName={tableName} />

        </div>
    );
};

export default Profile;
